import { HelmetDexteel } from "@dexteel/mesf-core";
import { StraightenerRunsReport } from "./components/StraightenerRunsReport";

export const StraightenerRunsPage = () => {
	return (
		<>
			<HelmetDexteel title="Straightener Runs" />
			<StraightenerRunsReport />
		</>
	);
};
